import { Grid, Box, Typography, Alert, Container } from '@mui/material';
import React, { useContext, useEffect } from 'react'
import AuthContext, { AuthState } from '../contexts/AuthContext';
import { useNavigate } from 'react-router';
import { forgottenPasswordRoute, homePageRoute, menuEditorRoute, selfSignupRoute, usePathReconstructor } from '../config/pageRoutes';
import LangSelector from '../lang/LangSelector';
import { LoginForm, LoginPageContainer, LoginPageContainerOverlay } from '../styles/containers';
import { useTranslation } from 'react-i18next';
import Footer from '../footer/Footer';
import { LoginTextInput } from '../styles/inputs';
import { GoogleLoginButton, GoogleLoginButtonTextContainer, GoogleLoginIconContainer, LoginButton } from '../styles/buttons';
import { primary } from '../styles/colors';
import GoogleIcon from '@mui/icons-material/Google';
import { Link } from 'react-router-dom';

type Props = {}

const LoginPage = (props: Props) => {
    const { t } = useTranslation();
    const { copyParamsFromPath } = usePathReconstructor()
    const [email, setEmail] = React.useState<string>('');
    const [password, setPassword] = React.useState<string>('');
    const { login, user, authState, errorMessage, googleLogin } = useContext(AuthContext);
    const navigate = useNavigate();
    const [requestErrorMessage, setRequestErrorMessage] = React.useState<string>('');

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setRequestErrorMessage("");
        const success = await login(email, password);
        if (success) {
            if (window.gtag) {
                window.gtag('event', 'login', {
                    method: 'email',
                    page_location: window.location.href
                });
            }
        } else {
            setRequestErrorMessage(t("auth.invalid_credentials"));
        }
    };

    function handleEmailChange(e: React.ChangeEvent<HTMLInputElement>) {
        setEmail(e.target.value);
    }

    function handlePasswordChange(e: React.ChangeEvent<HTMLInputElement>) {
        setPassword(e.target.value);
    }

    useEffect(() => {
        if (authState === AuthState.LOGGED_IN) {
            navigate(copyParamsFromPath(menuEditorRoute.path));
        }
    }, [authState, user]);

    return (
        <>
            <LoginPageContainer>
                <LoginPageContainerOverlay>
                    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
                        <Box pt={2} px={4}>
                            <Grid container>
                                <Grid item>
                                    <Link to={copyParamsFromPath(homePageRoute)}>
                                        <img
                                            src={process.env.REACT_APP_PUBLIC_URL + '/assets/logo_white.svg'}
                                            width={"80px"}
                                        />
                                    </Link>
                                </Grid>
                                <Grid item xs>
                                </Grid>
                                <Grid item>
                                    <Box pt={1}>
                                        <LangSelector />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <Container style={{ flex: "1", maxWidth: "1600px" }}>
                            <Box pt={3}>
                                <div className="flex">
                                    <div className="grow">
                                    </div>
                                    <div className="max-w-[500px]">
                                        <LoginForm px={3} pt={3} pb={8}>
                                            <div className="text-center">
                                                <Typography fontWeight={"bold"} fontSize="30px" mt={1} fontFamily="Avenir Next" color={primary.deep}>
                                                    {t("auth.sign_in")}
                                                </Typography>
                                            </div>
                                            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                                                <Box py={1}>
                                                    <LoginTextInput
                                                        placeholder={t("auth.email")}
                                                        value={email}
                                                        onChange={handleEmailChange}
                                                    />
                                                </Box>

                                                <Box py={1}>
                                                    <LoginTextInput
                                                        placeholder={t("auth.password")}
                                                        type="password"
                                                        value={password}
                                                        onChange={handlePasswordChange}
                                                    />
                                                </Box>
                                                {errorMessage != null && (
                                                    <Box py={2}>
                                                        <Alert severity='error' variant="filled" >
                                                            {errorMessage}
                                                        </Alert>
                                                    </Box>
                                                )}
                                                <Box py={1}>
                                                    <LoginButton
                                                        type="submit"
                                                    >
                                                        {t("auth.sign_in_button")}
                                                    </LoginButton>
                                                </Box>
                                                {requestErrorMessage && (
                                                    <Box py={2}>
                                                        <Alert severity='error' variant="filled" >
                                                            {requestErrorMessage}
                                                        </Alert>
                                                    </Box>)}
                                                <Box py={5}>
                                                    <GoogleLoginButton type="button" onClick={googleLogin}>
                                                        <div className="flex gap-3">
                                                            <div className="grow flex items-center pl-3 md:pl-6 pl-3 py-1">
                                                                <GoogleLoginButtonTextContainer>
                                                                    {t("auth.login_with_google")}
                                                                </GoogleLoginButtonTextContainer>
                                                            </div>
                                                            <div className="flex items-center">
                                                                <GoogleLoginIconContainer>
                                                                    <GoogleIcon />
                                                                </GoogleLoginIconContainer>
                                                            </div>
                                                        </div>
                                                    </GoogleLoginButton>
                                                </Box>
                                            </Box>
                                            <div className="flex flex-col text-center md:text-left gap-6 md:gap-0 md:flex-row justify-between underline">
                                                <Link to={copyParamsFromPath(selfSignupRoute.path)}>{t("auth.no_user_created_yet")}</Link>
                                                <Link to={copyParamsFromPath(forgottenPasswordRoute.path)}>{t("auth.forgotten_password")}</Link>
                                            </div>
                                        </LoginForm>
                                    </div>
                                </div>
                            </Box>
                        </Container>
                        <Footer />
                    </div>
                </LoginPageContainerOverlay>
            </LoginPageContainer>
        </>
    );
}

export default LoginPage